import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const ExploreBuildingRecording20261028Composition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={357}
			style={{
				width: 2102,
				height: 1440,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/building-remotion-capture-localhost-2026-10-28T14-10-57-153Z-2026-10-28-f37ebc370ecb.mp4'
				}
				durationInFrames={357}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[1, 5, 6, 67, 269],
					['auto', 'default', 'auto', 'default', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 52, 230, 311, 318],
						[
							2.867432580642652, 2.580689322578387, 2.867432580642652,
							2.580689322578387, 2.867432580642652,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							1, 2, 3, 4, 5, 6, 7, 8, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 63, 64,
							65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
							81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96,
							97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110,
							111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
							124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136,
							137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149,
							150, 151, 152, 153, 154, 155, 156, 157, 160, 161, 162, 163, 164,
							168, 169, 170, 171, 172, 173, 184, 185, 186, 187, 268, 269, 270,
							271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
							284, 285, 286, 287, 288, 291, 292, 293, 294, 295, 296, 302, 303,
							304, 305, 306,
						],
						[
							'1323.241729606957px 2583.3103351716304px',
							'1347.6037056339014px 2503.929496503605px',
							'1386.4372554662768px 2398.0473082816716px',
							'1423.0866281376157px 2191.4017470305926px',
							'1431.0280722769735px 1831.7629763303023px',
							'1437.7822201134093px 1590.0137677833868px',
							'1437.7822201134093px 1590.0137677833868px',
							'1461.2145207333483px 1422.8850117842892px',
							'1461.2145207333483px 1422.8850117842892px',
							'1550.373752537706px 907.8896399374617px',
							'1547.0470827078198px 883.0572257527555px',
							'1543.6196047012702px 862.5147595304952px',
							'1541.6482448020784px 853.7668499778315px',
							'1538.6127985936637px 839.2504725383282px',
							'1537.5935159185135px 831.5330465693329px',
							'1536.8430550477983px 811.7858448518602px',
							'1536.2942105304096px 783.1563226795063px',
							'1536.6638405115082px 746.977388165929px',
							'1537.9855477166482px 710.8880609204969px',
							'1538.6015976851456px 651.1872185188354px',
							'1539.6768849028865px 603.2921336952886px',
							'1544.6276864679023px 559.6981977427058px',
							'1550.0713280077161px 525.7930476583101px',
							'1554.4060796042345px 486.8474887407534px',
							'1555.3805586453122px 464.56888169818217px',
							'1553.5100069227838px 450.5117415079223px',
							'1548.3911917299959px 434.3824332418074px',
							'1542.7683356538919px 422.9127029192368px',
							'1539.4976703665964px 415.36329057801356px',
							'1538.2767713381197px 412.4622552718165px',
							'1537.9967486251662px 411.77899985221023px',
							'1537.9743468081301px 411.74539712665586px',
							'1537.9743468081301px 411.74539712665586px',
							'1537.9855477166482px 412.09262529071805px',
							'1538.7024058618088px 423.19272563219016px',
							'1538.7024058618088px 423.19272563219016px',
							'1539.452866732524px 429.1628098723563px',
							'1539.6096794517778px 431.80622428263626px',
							'1539.7552912625135px 433.64317327961044px',
							'1539.8224967136223px 434.3936341503255px',
							'1540.0689167010214px 435.2449031977038px',
							'1540.0913185180575px 436.14097587915467px',
							'1540.0913185180575px 436.56661040284376px',
							'1540.0913185180575px 437.742705797248px',
							'1540.0913185180575px 438.56037211907187px',
							'1540.0913185180575px 439.400440257932px',
							'1540.0913185180575px 440.4085220245642px',
							'1540.0913185180575px 441.46140742526893px',
							'1540.0913185180575px 442.06625648524823px',
							'1540.0913185180575px 443.39916459890634px',
							'1539.8560994391767px 444.2280318292484px',
							'1539.4976703665964px 445.98657446659564px',
							'1539.4416658240057px 447.095464409891px',
							'1539.1616431110524px 448.24915798725897px',
							'1539.1616431110524px 448.24915798725897px',
							'1538.803214038472px 450.01890153312434px',
							'1538.1759631614564px 453.60319225892766px',
							'1537.8735386314668px 454.79048856185px',
							'1537.559913192959px 456.0225884988449px',
							'1537.2126850288969px 457.73632750211965px',
							'1536.8430550477983px 460.6149609912804px',
							'1536.6190368774357px 461.6678463919851px',
							'1536.4174205241093px 462.5191154393634px',
							'1536.4174205241093px 462.9447499630526px',
							'1536.4174205241093px 463.56079993155004px',
							'1536.4174205241093px 463.807219918949px',
							'1536.4174205241093px 463.9080280956122px',
							'1536.4174205241093px 464.56888169818217px',
							'1536.1934023537465px 464.84890441113555px',
							'1536.1934023537465px 465.5545616477781px',
							'1536.0589914515288px 466.42823251219266px',
							'1535.7677678300574px 467.201095199944px',
							'1535.6221560193217px 467.71633699177823px',
							'1535.4429414830315px 468.3323869602757px',
							'1535.3085305808138px 469.23966055024465px',
							'1535.1181151360056px 469.90051415281465px',
							'1535.062110593415px 470.4605595787214px',
							'1534.7036815208344px 471.92787859459713px',
							'1534.4572615334355px 472.6783394653122px',
							'1534.4572615334355px 473.159978531592px',
							'1534.345252448254px 473.7872294086076px',
							'1534.0204261012282px 474.53769027932265px',
							'1533.6395952116115px 475.8481965759445px',
							'1533.101951602741px 477.1699037810845px',
							'1532.6987188960882px 478.39080280956125px',
							'1532.3850934575805px 479.6341036550742px',
							'1532.1162716531453px 480.44056906838px',
							'1532.0602671105546px 480.96701176873233px',
							'1531.6234316783473px 482.0422989864733px',
							'1531.0633862524405px 483.1287871127325px',
							'1530.7385599054146px 484.41689159231805px',
							'1530.436135375425px 485.5817860782041px',
							'1530.1785144795078px 486.3658496744736px',
							'1530.1225099369171px 486.4554569426187px',
							'1529.8984917665543px 487.8219677818312px',
							'1529.20403543843px 488.8748531825359px',
							'1528.946414542513px 489.6925195043598px',
							'1528.8568072743678px 490.27496674730287px',
							'1528.5207800188239px 491.17103942875366px',
							'1528.5207800188239px 491.17103942875366px',
							'1528.2519582143884px 491.8206921228055px',
							'1527.5911046118185px 493.5232302175621px',
							'1527.4902964351554px 494.46410653308544px',
							'1527.22147463072px 495.4273846656451px',
							'1526.9078491922123px 496.3458591641322px',
							'1526.5830228451864px 497.2867354796556px',
							'1526.2693974066785px 498.2164108866608px',
							'1525.9893746937253px 499.0340772084847px',
							'1525.7653565233625px 499.9189489814174px',
							'1525.563740170036px 500.66940985213245px',
							'1525.2725165485645px 501.375067088775px',
							'1524.9700920185749px 501.957514331718px',
							'1524.656466580067px 502.5735643002155px',
							'1524.3428411415593px 503.1784133601948px',
							'1524.152425696751px 503.39123062203936px',
							'1524.0516175200878px 503.7608606031378px',
							'1523.6707866304712px 504.5001205653347px',
							'1523.1779466556732px 505.3177868871586px',
							'1522.8195175830929px 506.0458459408374px',
							'1522.573097595694px 506.8971149882157px',
							'1522.2930748827405px 507.5243658652313px',
							'1522.248271248668px 507.70358040152144px',
							'1521.8898421760875px 508.42043854668213px',
							'1521.833837633497px 508.62205490000855px',
							'1521.5202121949892px 509.33891304516925px',
							'1521.4306049268441px 509.8317530199672px',
							'1521.2849931161084px 509.9661639221848px',
							'1521.2849931161084px 509.9661639221848px',
							'1520.8817604094554px 510.35819572031954px',
							'1520.848157683901px 510.6046157077185px',
							'1520.747349507238px 510.6942229758636px',
							'1520.512130428357px 510.9182411462263px',
							'1520.512130428357px 510.9182411462263px',
							'1520.1649022642948px 511.2542684017704px',
							'1519.7728704661602px 511.94872472989476px',
							'1519.4480441191342px 512.5759756069103px',
							'1519.1792223146988px 513.1920255754078px',
							'1519.1792223146988px 513.6288610076151px',
							'1519.1792223146988px 513.6288610076151px',
							'1518.8991996017455px 513.8976828120503px',
							'1518.5071678036109px 514.782554584983px',
							'1518.3951587184295px 515.0961800234908px',
							'1518.3951587184295px 515.0961800234908px',
							'1518.3951587184295px 518.2884389511594px',
							'1524.8580829333935px 588.6525462620857px',
							'1524.8580829333935px 588.6525462620857px',
							'1593.2620312536462px 1017.6137397811156px',
							'1608.2040432168387px 1283.6241161783123px',
							'1606.311089677274px 1541.3234184550524px',
							'1577.188727530122px 1871.8958315507814px',
							'1577.188727530122px 1871.8958315507814px',
							'1520.680144056129px 2167.9806473191716px',
							'1408.8950770451381px 2500.3004021437296px',
							'1367.0596837299026px 2578.348332698097px',
							'1343.0561367755386px 2619.1196397041094px',
							'1331.1607719292788px 2639.4044850304526px',
							'1321.9536251273714px 2655.9706287287745px',
							'1317.0140244708737px 2664.7857437325474px',
							'1314.8074454928012px 2669.893358016817px',
							'1312.7128755999097px 2675.202588654413px',
							'1311.6039856566144px 2679.9293720490664px',
							'1311.4695747543967px 2683.0880282511803px',
							'1311.4695747543967px 2684.768164528901px',
							'1311.4695747543967px 2684.768164528901px',
							'1310.5174975303553px 2692.4631886808597px',
							'1309.2069912337333px 2699.934194662456px',
							'1306.5075722808629px 2705.3330325681973px',
							'1304.2785914857539px 2709.936605969151px',
							'1304.211386034645px 2710.082217779887px',
							'1304.211386034645px 2710.082217779887px',
							'1307.190827700469px 2702.1295727320107px',
							'1309.7110321170494px 2691.5447141823724px',
							'1310.1926711833294px 2686.605113525875px',
							'1310.5398993473916px 2682.3599691975014px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
